import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-fire-icon',
  templateUrl: './general-fire.component.html'
})
export class GeneralFireComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
